import Swiper from 'swiper/swiper-bundle';

export const gallery = () => {
  var videoThumbs = new Swiper('.video-thumbs', {
    direction: 'vertical',
    spaceBetween: 10,
    slidesPerView: 4,
    freeMode: true,
    watchSlidesProgress: true,
    preloadImages: true,
  });

  var videoGallery = new Swiper('.video-swiper', {
    // scrollbar: '.swiper-scrollbar',
    // scrollbarHide: true,

    loop: false,
    slidesPerView: 'auto',
    spaceBetween: 14,
    autoHeight: true, //enable auto height
    thumbs: {
      swiper: videoThumbs,
    },
    breakpoints: {
      // when window width is >= 320px
      1280: {
        allowTouchMove: false,
        spaceBetween: 20,
      },
    },
  });

  $('.video-swiper .swiper-slide[data-youtube]').click(function (e) {
    e.preventDefault();
    //$('video', this).attr('autoplay', 'autoplay').attr('controls', 'controls');
    var videoPopup = $(this).attr('data-youtube');
    var popup =
      '<div class="video-popup" style="display:none;"><div class="popup-inner"><div class="aspect-w-16 aspect-h-9"><iframe width="1080" height="608" src="https://www.youtube.com/embed/' +
      videoPopup +
      '?autoplay=1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div><a class="video-closer" href="#">Close</a></div></div>';
    $('body').append(popup);
    $('.video-popup').fadeIn(250);
  });

  $('body').on('click', '.video-closer', function () {
    $('.video-popup').remove();
    return false;
  });
};
